import { WeekBase } from '../../shared/models/week-base';
import type { IGame } from '../../shared/interfaces/IGame';
import { Enumerable } from '../../shared/linq';

export class NflWeek extends WeekBase {
  constructor(Division: string) {
    super(Division);
  }

  /**
   * NFL-specific game sort logic:
   * - If first game has a gameDate: sort ascending by SortOrder, then by home TeamNameObs.
   * - If week >= 18 and no gameDate: sort ascending by gameScheduleNum.
   * - Otherwise: sort descending by SortOrder, then by home TeamNameObs.
   * - On exception: fall back to descending SortOrder.
   */
  protected override createGamesComputed(): KnockoutObservable<IGame>[] {
    const self = this;
    try {
      if (
        self.games() &&
        self.games().length &&
        self.games()[0] &&
        (self.games()[0] as KnockoutObservable<IGame>)().gameDate()
      ) {
        // Has gameDate — sort ascending by SortOrder then home TeamNameObs
        return Enumerable.From(self.games())
          .OrderBy((p: KnockoutObservable<IGame> | IGame) => {
            if (typeof p === 'function') {
              return (p as KnockoutObservable<IGame>)().SortOrder();
            }
            return (p as IGame).SortOrder();
          })
          .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
            if (typeof p === 'function') {
              return (p as KnockoutObservable<IGame>)().home().TeamNameObs();
            }
            return (p as IGame).home().TeamNameObs();
          })
          .ToArray() as KnockoutObservable<IGame>[];
      } else {
        const weekNum = (self.games()[0] as KnockoutObservable<IGame>)().week;
        if (weekNum >= 18) {
          // Playoff weeks — sort ascending by gameScheduleNum
          return Enumerable.From(self.games())
            .OrderBy((p: KnockoutObservable<IGame> | IGame) => {
              if (typeof p === 'function') {
                return (p as KnockoutObservable<IGame>)().gameScheduleNum();
              }
              return (p as IGame).gameScheduleNum();
            })
            .ToArray() as KnockoutObservable<IGame>[];
        }

        // Regular season, no gameDate — sort descending by SortOrder then home TeamNameObs
        return Enumerable.From(self.games())
          .OrderByDescending((p: KnockoutObservable<IGame> | IGame) => {
            if (typeof p === 'function') {
              return (p as KnockoutObservable<IGame>)().SortOrder();
            }
            return (p as IGame).SortOrder();
          })
          .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
            if (typeof p === 'function') {
              return (p as KnockoutObservable<IGame>)().home().TeamNameObs();
            }
            return (p as IGame).home().TeamNameObs();
          })
          .ToArray() as KnockoutObservable<IGame>[];
      }
    } catch (_ex) {
      // Fallback: descending by SortOrder then home TeamNameObs
      return Enumerable.From(self.games())
        .OrderByDescending((p: KnockoutObservable<IGame> | IGame) => {
          if (typeof p === 'function' && (p as KnockoutObservable<IGame>)()) {
            return (p as KnockoutObservable<IGame>)().SortOrder();
          }
          return (p as IGame).SortOrder();
        })
        .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
          if (p) {
            if (typeof p === 'function') {
              return (p as KnockoutObservable<IGame>)().home().TeamNameObs();
            }
            return (p as IGame).home().TeamNameObs();
          }
        })
        .ToArray() as KnockoutObservable<IGame>[];
    }
  }
}
